module.exports = __webpack_public_path__ + "static/media/group--clean-room.1ef70130.svg";